/* tslint:disable */
// @ts-nocheck
/* eslint-disable */
/**
 * Rana simulation API
 *
 * The version of the OpenAPI document: v3
 * Contact: info@nelen-schuurmans.nl
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

import { mapValues } from "../runtime";
/**
 *
 * @export
 * @interface BreachGraph
 */
export interface BreachGraph {
  /**
   *
   */
  url: string;
}

/**
 * Check if a given object implements the BreachGraph interface.
 */
export function instanceOfBreachGraph(value: object): value is BreachGraph {
  if (!("url" in value) || value["url"] === undefined) return false;
  return true;
}

export function BreachGraphFromJSON(json: any): BreachGraph {
  return BreachGraphFromJSONTyped(json, false);
}

export function BreachGraphFromJSONTyped(json: any, ignoreDiscriminator: boolean): BreachGraph {
  if (json == null) {
    return json;
  }
  return {
    url: json["url"],
  };
}

export function BreachGraphToJSON(json: any): BreachGraph {
  return BreachGraphToJSONTyped(json, false);
}

export function BreachGraphToJSONTyped(
  value?: BreachGraph | null,
  ignoreDiscriminator: boolean = false
): any {
  if (value == null) {
    return value;
  }

  return {
    url: value["url"],
  };
}
